/* src/app/layout/layout.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
router-outlet ::ng-deep + *,
.layout .main-content,
.layout .page-content-wrapper,
.layout .wrapper,
.layout,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.layout .layout-footer,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.layout {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
}
.layout.no-sidebar .page-content-wrapper {
  padding: 0 !important;
}
.layout upsc-site-announcement {
  position: fixed;
  width: 100%;
  z-index: 9999;
}
.layout upsc-site-announcement + .wrapper.with-site-announcement {
  margin-top: 52px;
}
.layout upsc-site-announcement + .wrapper.with-site-announcement ::ng-deep .side-bar-menu {
  height: calc(100% - 52px) !important;
}
.layout .wrapper {
  min-height: 100%;
  background-color: #f4f4f4;
}
@media screen and (min-width: 48rem) {
  .layout .wrapper.with-site-announcement {
    margin-top: 3.25rem;
  }
}
.layout .page-content-wrapper {
  min-height: 100%;
}
.layout .header-container {
  box-shadow: 1px 1px 2px 0 rgba(196, 196, 196, 0.5);
  z-index: 2;
}
.layout .layout-footer {
  display: none;
  margin-top: auto;
  padding: 2.5rem 0 2em 0;
}
@media screen and (min-width: 64rem) {
  .layout .layout-footer {
    display: block;
    font-size: 0.75em;
    color: #817b7b;
  }
}
mat-sidenav-container {
  margin: 0;
  padding: 0;
  height: 100%;
}
mat-sidenav {
  width: 20em;
}
mat-sidenav .sidenav-toggle {
  cursor: pointer;
}
mat-sidenav .sidenav-toggle .mat-icon {
  color: #404040;
  font-size: 3em;
  padding: 0.15em;
  margin-bottom: 1em;
}
@media print {
  .header-container,
  .layout-footer {
    visibility: hidden !important;
  }
}
/*# sourceMappingURL=layout.component.css.map */
